// 本文件为站点示例数据（虚构/匿名化，仅用于静态首页展示）
// 封面图统一使用 stable-diffusion 生成的编辑质感配图，避免指向真实个体。

export const coverDeep1 =
  "https://readdy.ai/api/search-image?query=editorial%20photography%20of%20a%20stack%20of%20archival%20documents%20and%20manila%20folders%20on%20a%20dark%20wooden%20desk%20with%20a%20vintage%20film%20camera%2C%20soft%20red%20rim%20light%2C%20warm%20dark%20cinematic%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20contrast%2C%20no%20people%20present&width=1000&height=640&seq=deep-01&orientation=landscape";

export const coverDeep2 =
  "https://readdy.ai/api/search-image?query=overhead%20editorial%20flat%20lay%20of%20a%20smartphone%20lying%20face-up%20on%20a%20dark%20table%20showing%20a%20glowing%20news%20feed%20screen%2C%20beside%20a%20cooling%20coffee%20cup%20and%20scattered%20printed%20pages%2C%20moody%20amber%20and%20red%20accent%20lighting%2C%20cinematic%2C%20no%20people%20present&width=1000&height=640&seq=deep-02&orientation=landscape";

export const coverFeature1 =
  "https://readdy.ai/api/search-image?query=close-up%20editorial%20shot%20of%20a%20professional%20microphone%20in%20front%20of%20softly%20blurred%20red%20and%20amber%20stage%20lights%20bokeh%2C%20dark%20atmospheric%20background%2C%20cinematic%20music%20scene%2C%20silhouette%20feel%2C%20no%20recognizable%20face&width=640&height=420&seq=feed-01&orientation=landscape";

export const heroData = {
  title: "国产黑料事件合集",
  sub: "把散在各处的瓜，按人物时间线收进一份能一次翻完的档案。",
  desc: "事件合集、深扒档案、人物梳理、最新猛料，按年份与主角归类摆放。想吃完整历史瓜、补全旧料，从这里直接开翻。",
  stats: [
    { value: "2,180+", label: "归档事件", icon: "ri-archive-line" },
    { value: "96", label: "深扒人物", icon: "ri-user-search-line" },
    { value: "2017–26", label: "时间跨度", icon: "ri-time-line" },
    { value: "38", label: "本月新增", icon: "ri-flashlight-line" },
  ],
};

export const latestItems = [
  {
    id: 1,
    tag: "直播现场",
    time: "今天 22:40",
    hot: true,
    title: "顶流主播深夜直播情绪失控，几段早年录音同步被网友回炉逐句对比",
    brief: "直播间弹幕吵翻天，旧料被翻出后时间线越对越乱，讨论区已盖起高楼。",
  },
  {
    id: 2,
    tag: "税务关联",
    time: "今天 16:05",
    title: "组合成员前团队被扒关联多家新注册公司，账目线索正被逐步拼图",
    brief: "爆料帖从企业登记页一路扒到旧公告，关联链条仍在更新。",
  },
  {
    id: 3,
    tag: "综艺考古",
    time: "昨天",
    title: "老牌综艺复活名单流出，几名『有前史』的嘉宾遭集体考古",
    brief: "名单真假待定，但评论区已经有人翻出当年的现场争议片段。",
  },
  {
    id: 4,
    tag: "带货售后",
    time: "3 天前",
    title: "头部带货账号被曝选品翻车后售后失联，累计投诉已上千条",
    brief: "从选品截图到退款截图都被放出，目前品牌与主播均未正面回应。",
  },
  {
    id: 5,
    tag: "感情线",
    time: "3 天前",
    title: "双人组搭档被拍同游，多年『人设不合』的旧同框又被重新解读",
    brief: "老粉翻出当年物料逐帧分析，站内搜索热度快速走高。",
  },
  {
    id: 6,
    tag: "学历核对",
    time: "5 天前",
    title: "练习生出道资料被扒时间线冲突，学历证明与履历对不上",
    brief: "多方凭证截图流传，围绕毕业年份的争议仍在发酵。",
  },
  {
    id: 7,
    tag: "品牌切割",
    time: "6 天前",
    title: "因过往争议，某品牌连夜删除与旗下艺人的全部合作物料",
    brief: "官网与社媒同步清空，代言是否终止成为当下最大悬念。",
  },
  {
    id: 8,
    tag: "现场原声",
    time: "1 周前",
    title: "商务活动现场原声流出，几句争议言论在讨论区持续刷屏",
    brief: "音频片段与逐字稿对照帖传播，官方尚未给出说明。",
  },
];

export const persons = [
  {
    code: "L-01",
    role: "男团主唱 · 已单飞",
    name: "艺人代号 L",
    line: "从选秀高光到合约撕扯，一条线串起五年变化。",
    span: "2021 — 2026",
    count: 27,
    accent: "primary",
    stages: [
      { year: "2021", title: "出道选秀期间被指集资流程存疑" },
      { year: "2023", title: "同框被拍，恋情与团体行程出现矛盾" },
      { year: "2024", title: "专辑销量数据遭质疑灌水" },
      { year: "2026", title: "单飞合约纠纷，与原公司各执一词" },
    ],
  },
  {
    code: "L-02",
    role: "头部带货主播",
    name: "主播代号 M",
    line: "带货翻车连着售后失联，人气跌速比涨速还快。",
    span: "2022 — 2026",
    count: 33,
    accent: "accent",
    stages: [
      { year: "2022", title: "直播间冲量规则被指误导下单" },
      { year: "2024", title: "明星背书商品被曝产地不符" },
      { year: "2025", title: "选品抽样造假截图流传" },
      { year: "2026", title: "大规模售后投诉爆发" },
    ],
  },
  {
    code: "L-03",
    role: "甜宠剧女演员",
    name: "演员代号 A",
    line: "人设与旧动态对不上，考古党一条条扒时间线。",
    span: "2019 — 2025",
    count: 19,
    accent: "primary",
    stages: [
      { year: "2019", title: "出道时公开言论被翻旧账" },
      { year: "2021", title: "待播剧未播先被质疑改年龄" },
      { year: "2023", title: "杀青照背景与宣传文案冲突" },
      { year: "2025", title: "旧账号动态流出，人设再受挑战" },
    ],
  },
  {
    code: "L-04",
    role: "户外挑战博主",
    name: "博主代号 K",
    line: "画面剪辑与实拍对不上，安全争议持续多季。",
    span: "2020 — 2026",
    count: 22,
    accent: "accent",
    stages: [
      { year: "2020", title: "成名挑战被指存在替拍与摆拍" },
      { year: "2022", title: "危险动作未设保护引全网质疑" },
      { year: "2024", title: "赞助合作在争议后紧急叫停" },
      { year: "2026", title: "团队声明与网友实拍仍各执一词" },
    ],
  },
  {
    code: "L-05",
    role: "说唱歌手",
    name: "歌手代号 R",
    line: "台上台下两套说辞，押韵之外全是节奏外料。",
    span: "2018 — 2025",
    count: 24,
    accent: "primary",
    stages: [
      { year: "2018", title: "早期歌词被逐句解读上热搜" },
      { year: "2020", title: "合作纠纷导致歌曲临时下架" },
      { year: "2023", title: "巡演延期公告引发退票维权" },
      { year: "2025", title: "海外行程与国内活动档期撞车" },
    ],
  },
  {
    code: "L-06",
    role: "偶像剧男演员",
    name: "演员代号 C",
    line: "戏里好男人，戏外旧照与截图互相打脸。",
    span: "2017 — 2026",
    count: 30,
    accent: "accent",
    stages: [
      { year: "2017", title: "出道早期言论被考古挖出" },
      { year: "2019", title: "深夜同框视频流出" },
      { year: "2022", title: "律师声明与公开记录存在出入" },
      { year: "2026", title: "新剧宣传期旧料被集中回炉" },
    ],
  },
  {
    code: "L-07",
    role: "情感电台主播",
    name: "主播代号 S",
    line: "教人真诚的人设，自己先被扒出言行两面。",
    span: "2019 — 2025",
    count: 16,
    accent: "primary",
    stages: [
      { year: "2019", title: "匿名小号被指关联本人" },
      { year: "2021", title: "节目停更与个人生活变动同步" },
      { year: "2023", title: "付费答疑被指答非所问" },
      { year: "2025", title: "过往私信截图集中流出" },
    ],
  },
  {
    code: "L-08",
    role: "选秀回锅选手",
    name: "选手代号 T",
    line: "二次参赛热度上升，旧期黑历史也被同步翻出。",
    span: "2020 — 2026",
    count: 18,
    accent: "accent",
    stages: [
      { year: "2020", title: "初赛淘汰后复出小号被扒" },
      { year: "2022", title: "与粉丝集资相关的旧帖重见天日" },
      { year: "2024", title: "练习室冲突画面被公开" },
      { year: "2026", title: "回归舞台前后旧料再次集中盘点" },
    ],
  },
];

export const compilations = [
  {
    theme: "选秀集资与打投乱象",
    count: 28,
    years: "2018—2026",
    desc: "从应援集资到票数水分，围绕选秀赛制的一整套流水线问题。",
    tags: ["选秀", "集资", "数据"],
  },
  {
    theme: "直播带货翻车实录",
    count: 31,
    years: "2020—2026",
    desc: "选品、话术、售后三条线反复出事，爆款背后藏着一串连锁。",
    tags: ["带货", "售后", "选品"],
  },
  {
    theme: "感情与『塌房』盘点",
    count: 44,
    years: "2017—2026",
    desc: "官宣、分手、被拍三件套轮番上演，人设与私生活互相拉扯。",
    tags: ["感情", "塌房", "人设"],
  },
  {
    theme: "税务与商务纠纷",
    count: 19,
    years: "2019—2026",
    desc: "注册公司、补税、解约公告，商务动作背后常跟着一串问号。",
    tags: ["税务", "合约", "解约"],
  },
  {
    theme: "学历履历造假合集",
    count: 12,
    years: "2018—2025",
    desc: "毕业证、艺考、出道年份，一查证就现形的资料对不上现场。",
    tags: ["学历", "履历", "考古"],
  },
  {
    theme: "综艺考古名场面",
    count: 36,
    years: "2015—2026",
    desc: "当年没注意到的现场细节，多年后被翻出来逐帧慢放。",
    tags: ["综艺", "名场面", "考古"],
  },
];

export const yearAxis = [
  {
    year: "2026",
    label: "今年",
    note: "新瓜不断线",
    items: [
      { time: "09 月", title: "多名主播进入集中复盘，售后类投诉显著增加" },
      { time: "07 月", title: "组合成员个人合约变动引发连锁解读" },
      { time: "05 月", title: "选秀系艺人回归，旧集资帖再度翻红" },
      { time: "03 月", title: "品牌集中切割潮，合作物料批量下架" },
    ],
  },
  {
    year: "2025",
    label: "前一年",
    note: "集中整顿年",
    items: [
      { time: "11 月", title: "直播规则收紧，主播话术翻车案例激增" },
      { time: "08 月", title: "一部待播剧主创履历遭连环核对" },
      { time: "04 月", title: "情感类账号人设连环塌房" },
    ],
  },
  {
    year: "2024",
    label: "爆发年",
    note: "瓜量峰值",
    items: [
      { time: "12 月", title: "跨年演出阵容变动，退票维权同步发酵" },
      { time: "09 月", title: "专辑销量数据造假质疑集中爆发" },
      { time: "06 月", title: "综艺录制冲突画面被大量转发" },
    ],
  },
  {
    year: "2023",
    label: "人设崩塌年",
    note: "考古兴起",
    items: [
      { time: "10 月", title: "杀青照与宣传文案矛盾，被逐张比对" },
      { time: "05 月", title: "恋综嘉宾旧账号动态大规模流出" },
      { time: "02 月", title: "带货退换货政策引新一轮讨论" },
    ],
  },
  {
    year: "2022",
    label: "带货元年",
    note: "坑位混战",
    items: [
      { time: "12 月", title: "年货节大促售后问题集中爆发" },
      { time: "08 月", title: "直播冲量话术被监管点名" },
      { time: "03 月", title: "多个合作方同步发布终止公告" },
    ],
  },
  {
    year: "2021",
    label: "资本入局",
    note: "饭圈打投",
    items: [
      { time: "11 月", title: "打投规则争议持续登上榜单" },
      { time: "06 月", title: "应援集资明细被粉丝团体公开" },
      { time: "02 月", title: "选秀赛制问题引发集中讨论" },
    ],
  },
];

export const deepArchiveItems = [
  {
    no: "档案 01",
    kind: "组合专题 · 深扒",
    minutes: "阅读约 18 分钟",
    cover: "coverDeep1",
    title: "一场『解散』背后的第三年：从舞台高光到分账与合约的时间线重构",
    lead: "把公开的舞台片段、公司公告与当事人发言放到同一条时间轴上，看看真正在线的，是瓜还是账。",
    points: ["资金流水与打投", "合约分账内幕", "官宣前 90 天"],
  },
  {
    no: "档案 02",
    kind: "带货专题 · 复盘",
    minutes: "阅读约 12 分钟",
    cover: "coverDeep2",
    title: "带货一姐的『选品事故』：售后失联前，哪些信号其实早就亮了",
    lead: "从选品环节到售后政策逐项复盘，扒清一次翻车是偶然还是被忽略的连锁。",
    points: ["选品抽检", "售后话术", "品牌切割时间"],
  },
];